const styles = theme => ({
  root: {
    marginTop: 24,
    marginLeft: 24,
    marginBottom: 24,
    textAlign: 'left',
    alignItems: 'left',
  },
  content: {
    textAlign: 'left',
    paddingLeft: 24,
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/User/scenes/Core/components/Occupation/styles.js